// extracted by mini-css-extract-plugin
export default {"singleProduct":"SingleProduct_singleProduct__sovJg","singleProduct__img":"SingleProduct_singleProduct__img__NLyxH"};